import { useRecordContext } from "ra-core";
import { ReferenceArrayField } from "@/components/admin/reference-array-field";
import { SingleFieldList } from "@/components/admin/single-field-list";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const ColoredBadge = (props: any) => {
  const record = useRecordContext();
  if (!record) return null;
  const isServopa = record.name === "Servopa Client";
  const badgeLabel = isServopa ? "Servopa" : record.name;
  const badgeColor = isServopa ? "#C62828" : record.color;
  return (
    <Badge
      {...props}
      style={{ backgroundColor: badgeColor, border: 0 }}
      variant="outline"
      className={cn("text-white font-normal", props.className)}
    >
      {badgeLabel}
    </Badge>
  );
};

export const TagsList = () => (
  <ReferenceArrayField
    className="inline-block"
    resource="contacts"
    source="tags"
    reference="tags"
  >
    <SingleFieldList>
      <ColoredBadge source="name" />
    </SingleFieldList>
  </ReferenceArrayField>
);
